var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnthropic = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  fillRule: "evenodd",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.827 3.76h3.603L24 20.24h-3.603zm-7.258 0h3.767l6.57 16.48h-3.674l-1.343-3.461H5.017l-1.344 3.46H0L6.57 3.762zm4.132 9.959L8.453 7.927 6.205 13.72H10.7z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnthropic);
export default ForwardRef;